import React, { useState, useEffect } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Modal,
  Box
} from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import { fetchallcitylist, fetchchapterbyuser } from "src/utils/common";
import Select from "react-select";
import { notification } from "src/utils/messages";
import DataTable from "react-data-table-component";
import { RemoveRedEye } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import { askApproveReject, getAskRejectReason, getAsksList } from "src/api/commonapi";
import Label from "src/components/Label";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Routes } from "src/constant/api_url";
import CustomLoader from "src/commonComponents/CustomLoader";
import normalizeSearch from "src/utils/normalizeSearch";

export default function Asks() {
  const askDetailModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const memberActiveType = [
    { label: "All", value: 0 },
    { label: "Active Member", value: 1 },
    { label: "De-Active Member", value: 2 }
  ];

  const askType = [
    { label: "All", value: -1 },
    { label: "General", value: 0 },
    { label: "Specific", value: 1 },
    { label: "Feed", value: 2 }
  ];

  const askFor = [
    { label: "All", value: -1 },
    { label: "India", value: 0 },
    { label: "City", value: 1 }
  ];

  const askStatus = [
    { label: "All", value: -1 },
    { label: "Open", value: 0 },
    { label: "Fulfill", value: 1 }
  ];
  const askApproveRejectOptions = [
    { label: "All", value: -1 },
    { label: "Approved", value: 0 },
    { label: "Rejected", value: 1 }
  ];

  const memberPosition = [
    { label: "All", value: 0 },
    { label: "LT", value: 1 },
    { label: "Director", value: 2 },
    { label: "Member", value: 3 }
  ];

  const [rejectModal, setRejectModal] = useState(false);
  const [confirmApproveModal, setConfirmApproveModal] = useState(false);
  const [selectedAsk, setSelectedAsk] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [chaptlist, setchaplist] = useState([]);
  const [searchdata, setsearchdata] = useState({
    city_id:
      loginUser?.u_type == 1 ||
      (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
        ? loginUser?.city_id
        : 0,
    chpt_id: 0,
    activeMemberSearchType: 0,
    activePositionType: 0,
    asksType: -1,
    // asksFor: -1,
    asksStatus: -1,
    asksApproveReject: -1,
    searchmember: "",
    startDate: null,
    endDate: null
  });
  const [asksData, setasksData] = useState([]);
  const [newAsksData, setNewAsksData] = useState([]);

  const [askRejectReason, setAskRejectReason] = useState([]);

  useEffect(async () => {
    setchaplist(await fetchchapterbyuser(loginUser.city_id, loginUser.u_type));
  }, []);

  const expo_columns = [
    { label: "No", key: "m_id" },
    { label: "Name", key: "m_name" },
    { label: "Business Name", key: "business_name" },
    { label: "Total Meeting", key: "total" },
    { label: "Present", key: "present" },
    { label: "Absent", key: "absent" }
  ];

  const columns = [
    {
      name: "No",
      selector: (row) => row.asks_id,
      wrap: true,
      width: "100px",
      sortable: true
    },
    {
      name: "Member Name",
      wrap: true,
      selector: (row) => row.m_name,
      sortable: true
    },
    {
      name: "Chapter Name",
      wrap: true,
      selector: (row) => row.chpt_name,
      sortable: true
    },
    {
      name: "Position",
      wrap: true,
      selector: (row) => (
        <div style={{ overflow: "visible", whiteSpace: "pre-line" }}>
          {row.member_new_position}
          <br />
          {row.combined_director != null && " " + row.combined_director}
        </div>
      ),
      sortable: true
    },
    {
      name: "Ask Date",
      wrap: true,
      selector: (row) => row.asks_date,
      sortable: true
    },
    {
      name: "Ask Type",
      wrap: true,
      selector: (row) => row.asksType,
      sortable: true
    },
    {
      name: "Feed Image",
      cell: (row) =>
        row.feed_img ? (
          <a
            href={`${Routes.API_HOSTNAME}images/asks/${row.feed_img}`}
            target="_blank"
            rel="noreferrer"
          >
            <img src={`${Routes.API_HOSTNAME}images/asks/${row.feed_img}`} alt="img" width="100" />
          </a>
        ) : (
          "-"
        ),
      width: "150px"
    },
    // {
    //   name: "Ask For",
    //   wrap: true,
    //   selector: (row) => row.asksFor,
    //   sortable: true
    // },
    {
      name: "Ask Status",
      wrap: true,
      selector: (row) => row.asksStatus,
      sortable: true
    },
    {
      name: "Approve/Reject",
      width: "120px",
      selector: (row) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "5px auto"
          }}
        >
          <Label variant={"ghost"} color={row.ask_approve_reject == 0 ? "success" : "error"}>
            {row.ask_approve_reject == 0 ? "Approve" : "Reject"}
          </Label>
          {loginUser?.u_type != 2 && (
            <Button
              className="bnt-btn-success"
              style={{
                padding: "2px 10px",
                marginTop: "5px",
                color: "white",
                backgroundColor: row.ask_approve_reject != 0 ? "#229A16" : undefined
              }}
              color={row.ask_approve_reject == 0 ? "error" : "success"}
              variant="contained"
              onClick={(e) => {
                setSelectedAsk(row);
                if (row.ask_approve_reject == 0) {
                  setRejectModal(true); // Open reject modal
                } else {
                  setConfirmApproveModal(true); // Open approve confirmation
                }
              }}
            >
              {row.ask_approve_reject == 0 ? "Reject" : " Approve"}
            </Button>
          )}
        </div>
      )
    }
  ];

  const ClearSearchResult = async () => {
    setsearchdata({
      city_id:
        loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.p_user_id != 1 && loginUser?.management_p == 1)
          ? loginUser?.city_id
          : 0,
      chpt_id: 0,
      activeMemberSearchType: 0,
      activePositionType: 0,
      asksType: -1,
      // asksFor: -1,
      asksStatus: -1,
      asksApproveReject: -1,
      searchmember: "",
      startDate: null,
      endDate: null
    });
  };

  const [citylist, setcitylist] = useState([]);

  const getallcitylist = async () => {
    setcitylist(await fetchallcitylist());
  };
  useEffect(async () => {
    getallcitylist();
  }, []);

  const filterData = () => {
    let selectedCityChapter =
      chaptlist &&
      chaptlist
        ?.map((chpt) => {
          if (searchdata?.city_id != 0) {
            if (chpt?.city_id == searchdata?.city_id) {
              return chpt.chpt_id;
            }
          } else {
            return chpt.chpt_id;
          }
        })
        .filter((f) => f != undefined);

    const AsksList =
      asksData &&
      asksData.filter((ask) => {
        const askDate = ask.asks_date ? new Date(ask.asks_date) : null;
        const startDate = searchdata.startDate ? new Date(searchdata.startDate) : null;
        const endDate = searchdata.endDate ? new Date(searchdata.endDate) : null;

        let dateMatch = true;
        if (startDate && endDate && askDate) {
          // Remove time from comparison
          askDate.setHours(0, 0, 0, 0);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          dateMatch = askDate >= startDate && askDate <= endDate;
        }

        if (
          (ask.chpt_id == searchdata?.chpt_id ||
            searchdata?.chpt_id == 0 ||
            (ask.launch_director != null && ask.launch_director_at == searchdata?.chpt_id) ||
            (ask.support_director != null && ask.support_director_at == searchdata?.chpt_id)) &&
          selectedCityChapter.length != 0 &&
          selectedCityChapter.includes(ask.chpt_id) &&
          (searchdata?.activeMemberSearchType == 0
            ? ask.status == 0 || ask.status == 1
            : searchdata?.activeMemberSearchType == 1
              ? ask.status == 1
              : ask.status == 0) &&
          (searchdata?.activePositionType == 0
            ? ask.type == -1 ||
              ask.type == 0 ||
              ask.type == 1 ||
              ask.type == 2 ||
              ask.type == 3 ||
              ask.type == 4 ||
              ask.type == 5
            : searchdata.activePositionType == 1
              ? ask.type == 1 || ask.type == 2 || ask.type == 3 || ask.type == 4
              : searchdata?.activePositionType == 2
                ? (ask.launch_director != null &&
                    (ask.launch_director_at == searchdata?.chpt_id || searchdata?.chpt_id == 0)) ||
                  (ask.support_director != null &&
                    (ask.support_director_at == searchdata?.chpt_id || searchdata?.chpt_id == 0))
                : ask.type == -1 ||
                  ask.type == 0 ||
                  ask.type == 1 ||
                  ask.type == 2 ||
                  ask.type == 3 ||
                  ask.type == 4 ||
                  ask.type == 5) &&
          (searchdata?.asksType == -1
            ? ask.ask_type == 0 || ask.ask_type == 1 || ask.ask_type == 2
            : searchdata?.asksType == 1
              ? ask.ask_type == 1
              : searchdata?.asksType == 2
                ? ask.ask_type == 2
                : ask.ask_type == 0) &&
          // (searchdata?.asksFor == -1
          //   ? ask.ask_for == 0 || ask.ask_for == 1
          //   : searchdata?.asksFor == 1
          //   ? ask.ask_for == 1
          //   : ask.ask_for == 0) &&
          (searchdata?.asksStatus == -1
            ? ask.ask_status == 0 || ask.ask_status == 1
            : searchdata?.asksStatus == 1
              ? ask.ask_status == 1
              : ask.ask_status == 0) &&
          (searchdata?.asksApproveReject == -1
            ? ask.ask_approve_reject == 0 || ask.ask_approve_reject == 1
            : searchdata?.asksApproveReject == 1
              ? ask.ask_approve_reject == 1
              : ask.ask_approve_reject == 0) &&
          dateMatch &&
          (ask.m_name.toLowerCase().includes(normalizeSearch(searchdata?.searchmember)) ||
            ask.business_name.toLowerCase().includes(normalizeSearch(searchdata?.searchmember)) ||
            ask.business_category.toLowerCase().includes(normalizeSearch(searchdata?.searchmember)) ||
            ask.mobile_no.toLowerCase().includes(normalizeSearch(searchdata?.searchmember)))
        ) {
          return ask;
        }
      });

    setNewAsksData(AsksList);
  };

  useEffect(() => {
    filterData();
  }, [searchdata, asksData]);

  const GetAsksData = async () => {
    setIsLoading(true);
    let res = await getAsksList(loginUser.city_id, loginUser.u_type);
    setIsLoading(false);
    if (res?.data?.length > 0) {
      setasksData(res?.data);
    } else {
      setasksData([]);
    }
  };
  useEffect(async () => {
    GetAsksData();
    getAskRejectReasonData();
  }, []);

  const getAskRejectReasonData = async () => {
    let res = await getAskRejectReason();
    setAskRejectReason(res);
  };

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        {data?.asks_note != null && data?.asks_note != "" && (
          <p>
            <b>Ask Note</b> : {data?.asks_note}
          </p>
        )}
        {data?.name != null && data?.name != "" && (
          <p>
            <b>Name</b> : {data?.name}
          </p>
        )}
        {data?.designation != null && data?.designation != "" && (
          <p>
            <b>Designation</b> : {data?.designation}
          </p>
        )}
        {data?.company_name != null && data?.company_name != "" && (
          <p>
            <b>Company Name</b> : {data?.company_name}
          </p>
        )}
        {data?.location != null && data?.location != "" && (
          <p>
            <b>Location</b> : {data?.location}
          </p>
        )}
        {data?.description != null && data?.description != "" && (
          <p>
            <b>Description</b> : {data?.description}
          </p>
        )}
        {data?.ask_reject_reason != null && data?.ask_reject_reason != "" && (
          <p>
            <b>Rejected Reason</b> : {data?.ask_reject_reason}
          </p>
        )}
        {data?.rejected_date != null && data?.rejected_date != "" && (
          <p>
            <b>Rejected Reason Date</b> : {data?.rejected_date}
          </p>
        )}
        {data?.feed_desc != null && data?.feed_desc != "" && (
          <p>
            <b>Feed Description</b> : {data?.feed_desc}
          </p>
        )}
      </div>
    );
  };

  return (
    <>
      <Page title="Asks | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Asks
            </Typography>
          </Stack>
          <Card className="p-20">
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <Stack>
                  <label>Select City</label>
                  <Select
                    menuPortalTarget={document.body}
                    isDisabled={
                      loginUser?.u_type == 1 ||
                      (loginUser?.u_type == 2 &&
                        loginUser?.p_user_id != 1 &&
                        loginUser?.management_p == 1)
                        ? true
                        : false
                    }
                    options={[
                      {
                        value: 0,
                        label: "All City"
                      },
                      ...citylist.map((city) => {
                        return {
                          label: city?.city_name,
                          value: city?.city_id
                        };
                      })
                    ]}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        city_id: e.value,
                        chpt_id: 0
                      });
                    }}
                    value={
                      searchdata.city_id == 0
                        ? {
                            value: 0,
                            label: "All City"
                          }
                        : citylist.map((city) => {
                            return (
                              searchdata.city_id == city.city_id && {
                                value: city.city_id,
                                label: city.city_name
                              }
                            );
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Select Chapter</label>
                  <Select
                    name="chpt_id"
                    menuPortalTarget={document.body}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        chpt_id: e.value
                      });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All Chapter"
                      },
                      ...(chaptlist &&
                        chaptlist
                          ?.map((chpt) => {
                            if (searchdata?.city_id != 0) {
                              if (searchdata?.city_id == chpt?.city_id) {
                                return {
                                  value: chpt.chpt_id,
                                  label: chpt.chpt_name
                                };
                              }
                            } else {
                              return {
                                value: chpt.chpt_id,
                                label: chpt.chpt_name
                              };
                            }
                          })
                          .filter((f) => f != undefined))
                    ]}
                    value={
                      searchdata.chpt_id == 0
                        ? { value: 0, label: "All Chapter" }
                        : chaptlist &&
                          chaptlist.map((c) => {
                            if (c.chpt_id == searchdata.chpt_id) {
                              return {
                                value: c.chpt_id,
                                label: c.chpt_name
                              };
                            }
                          })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Member Active Type</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      memberActiveType &&
                      memberActiveType.map((option) => {
                        if (option.value == searchdata.activeMemberSearchType) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, activeMemberSearchType: e.value });
                    }}
                    options={
                      memberActiveType &&
                      memberActiveType.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Member Position</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={memberPosition.map((c) => {
                      if (c.value == searchdata.activePositionType) {
                        return { value: c.value, label: c.label };
                      }
                    })}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        activePositionType: e.value
                      });
                    }}
                    options={memberPosition}
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Ask Type</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      askType &&
                      askType.map((option) => {
                        if (option.value == searchdata.asksType) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, asksType: e.value });
                    }}
                    options={
                      askType &&
                      askType.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              {/* <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Ask For</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      askFor &&
                      askFor.map((option) => {
                        if (option.value == searchdata.asksFor) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, asksFor: e.value });
                    }}
                    options={
                      askFor &&
                      askFor.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid> */}

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Ask Status</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      askStatus &&
                      askStatus.map((option) => {
                        if (option.value == searchdata.asksStatus) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, asksStatus: e.value });
                    }}
                    options={
                      askStatus &&
                      askStatus.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={2}>
                <Stack spacing={3}>
                  <label>Ask Approve/Reject</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      askApproveRejectOptions &&
                      askApproveRejectOptions.map((option) => {
                        if (option.value == searchdata.asksApproveReject) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, asksApproveReject: e.value });
                    }}
                    options={
                      askApproveRejectOptions &&
                      askApproveRejectOptions.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} style={{ marginTop: "0px" }}>
                    <label>Select Ask Start Date</label>
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Start Date "
                      inputFormat="dd/MM/yyyy"
                      value={searchdata.startDate != null ? searchdata.startDate : null}
                      onChange={(newDate) => {
                        setsearchdata({
                          ...searchdata,
                          startDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={0}>
                  <label>Select Ask End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="End Date "
                      inputFormat="dd/MM/yyyy"
                      value={searchdata.endDate != null ? searchdata.endDate : null}
                      onChange={(newDate) => {
                        setsearchdata({
                          ...searchdata,
                          endDate: newDate
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          // onKeyDown={(e) => e.preventDefault()}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={3}>
                  <label>Search Member</label>
                  <TextField
                    style={{ marginTop: "0px" }}
                    autoComplete="off"
                    type="text"
                    size="small"
                    label="Search Member"
                    name="search"
                    value={searchdata?.searchmember ? searchdata?.searchmember : ""}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        searchmember: e.target.value
                      });
                    }}
                  />
                </Stack>
              </Grid>

              <Grid
                xs={1}
                item
                sx={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card style={{ marginTop: "15px" }}>
            {asksData && (
              <>
                {/* <Button className="btn btn-export">
                  <CSVLink
                    data={asksData}
                    headers={expo_columns}
                    filename={"Asks.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button> */}
                <DataTable
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={newAsksData != null ? newAsksData : []}
                  expandableRows
                  expandableRowsComponent={ExpandableRow}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>

        {/* Reject Reason Modal */}
        <Modal open={rejectModal} onClose={() => setRejectModal(false)}>
          <Box sx={askDetailModalStyle}>
            <Typography variant="h6" textAlign="center">
              Reject Reason
            </Typography>
            <Select
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 1300 })
              }}
              onChange={(e) => {
                setRejectReason(e.value);
              }}
              options={askRejectReason?.map((reasons) => ({
                label: reasons?.ask_reject_reason,
                value: reasons?.a_r_reason_id
              }))}
            />
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                color="error"
                onClick={async () => {
                  if (!rejectReason) {
                    notification({
                      type: "error",
                      message: "Please select a reject reason."
                    })();
                    return;
                  }

                  const res = await askApproveReject({
                    asks_id: selectedAsk?.asks_id,
                    ask_approve_reject: 1,
                    rejected_reason: rejectReason
                  });

                  if (res.status == 1) {
                    let notify = notification({
                      type: res.status == 0 ? "error" : "success",
                      message: res.message
                    });
                    notify();
                    GetAsksData(); // refresh data
                  }
                  setRejectModal(false);
                  setRejectReason("");
                }}
              >
                Submit
              </Button>
              <Button variant="outlined" onClick={() => setRejectModal(false)}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>

        {/* Approve Confirmation Modal */}
        <Modal open={confirmApproveModal} onClose={() => setConfirmApproveModal(false)}>
          <Box sx={askDetailModalStyle}>
            <Typography variant="h6" textAlign="center">
              Are you sure you want to approve this ask?
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                className="btn btn-primary"
                onClick={async () => {
                  const res = await askApproveReject({
                    asks_id: selectedAsk?.asks_id,
                    ask_approve_reject: 0
                  }); // 0 = approve
                  if (res.status == 1) {
                    let notify = notification({
                      type: res.status == 0 ? "error" : "success",
                      message: res.message
                    });
                    notify();
                    GetAsksData(); // refresh data
                  }
                  setConfirmApproveModal(false);
                }}
              >
                Yes, Approve
              </Button>
              <Button variant="outlined" onClick={() => setConfirmApproveModal(false)}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>
      </Page>
    </>
  );
}
